<template>
    <div :style="{ width: '100%', height: '100%' }">
      <div
        ref="dom"
        :id="chartId"
        :style="{ width: '100%', height: '100%' }"
      ></div>
    </div>
    <!-- <div style="width: 100%; height: 100%">
      <div ref="dom" :id="chartId" class="chartsdom"></div>
    </div> -->
    <!-- <div style="width: 100%; height: 100%">
      <div ref="dom" :id="chartId" style="width: 100%; height: 100%"></div>
      <div class="echartSpin" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
    </div> -->
  </template>
  <script>
  import echarts from 'echarts'
  const addListen = (function() {
    if (document.addEventListener) {
      return function(element, event, handler) {
        if (element && event && handler) {
          element.addEventListener(event, handler, false)
        }
      }
    } else {
      return function(element, event, handler) {
        if (element && event && handler) {
          element.attachEvent('on' + event, handler)
        }
      }
    }
  })()
  const removeListen = (function() {
    if (document.removeEventListener) {
      return function(element, event, handler) {
        if (element && event) {
          element.removeEventListener(event, handler, false)
        }
      }
    } else {
      return function(element, event, handler) {
        if (element && event) {
          element.detachEvent('on' + event, handler)
        }
      }
    }
  })()
  export default {
    name: 'EXCharts',
    props: {
      options: {
        type: Object,
        default: () => ({})
      },
      loading: {
        type: Boolean,
        default: false
      },
      autoPlay: {
        type: Boolean,
        default: false
      },
      autoPlayTime: {
        type: Number,
        default: 3000
      },
      ready:Function
    },
    data() {
      return {
        chartId: null,
        myChart: null,
        currentIndex: -1,
        autoPlayEvent: null,
        
      }
    },
    mounted() {
       this.myChart = echarts.init(this.$refs.dom)                               
       this.$emit('ready', this.myChart)
  
      // this.chartId = `echart-id-${Math.random()}`
      // this.reload()
      // this.myChart = echarts.init(this.$refs.dom)
      // this.myChart.setOption(this.options)
      // setTimeout(() => {
      //     window.onresize = function() {
      //       this.myChart.resize()
      //     }
      //   }, 200)
    },
    watch: {
      // options: {
      //   handler(value) {
      //     console.log('value//',value)
      //     this.reload()
      //   },
      //   deep: true
      //   // immediate: true
      // }
    },
    methods: {
      setOption(option) {    
        if (this.myChart) {
          this.myChart.setOption(option, true)
          setTimeout(() => {
            this.resize()
          }, 100)
        }
      },
      resize() {   
        if (this.myChart) {     
            this.myChart.resize()      
        }
      },
      registerMap(geoJson){
        echarts.registerMap('北京市', geoJson);
      },
      reload() {
      console.log('reload')
      // this.$nextTick(() => {
        // if (this.$refs.dom) {
          // console.log(this.$refs.dom,'0000')
          this.myChart = echarts.init(this.$refs.dom)

          // 若dom尺寸变化，则resize
          const chartObserver = new ResizeObserver(() => {
              if (this.myChart) {     
                this.myChart.resize();
              }
          });
          chartObserver.observe(this.$refs.dom);


          this.myChart.setOption(this.options)
          addListen(window, 'resize', this.resize)
          // this.myChart.off('click')
          // this.myChart.on('click', params => {
          //   this.$emit('nodeClick', params)
          // })
          // this.myChart.on('mouseover', params => {
          //   if (this.autoPlayEvent) {
          //     clearInterval(this.autoPlayEvent)
          //   }
          // })
          // this.myChart.on('mouseout', params => {
          //   if (this.autoPlay) {
          //     this.$_autoPlay()
          //   }
          // })
          // const myChart2 = echarts.getInstanceByDom(document.getElementById(this.chartId))
          // if (this.autoPlay) {
          //   this.$_autoPlay()
          // }
        // }
      // })
    },
      dispose() {
        if (this.myChart) {
          this.myChart.dispose()
          this.myChart = null
          this.currentIndex = -1
        }
      },
      $_autoPlay() {
        const dataLength = this.options.series[0].data.length
        if (this.autoPlayEvent) {
          clearInterval(this.autoPlayEvent)
          this.autoPlayEvent = null
        }
        this.autoPlayEvent = setInterval(() => {
          if (!this.myChart) {
            return
          }
          // 取消之前高亮的图形
          this.myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: this.currentIndex
          })
          this.currentIndex = (this.currentIndex + 1) % dataLength
          // 高亮当前图形
          this.myChart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: this.currentIndex
          })
          // 显示 tooltip
          this.myChart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: this.currentIndex
          })
        }, this.autoPlayTime)
      }
    },
    beforeDestroy() {
      if (this.myChart) {
        removeListen(window, 'resize', this.resize)
        this.myChart.dispose()
        this.myChart = null
      }
    }
  }
  </script>
  <style scoped lang="scss">
  .echartSpin {
    height: 100%;
    width: 100%;
    z-index: 99;
    position: relative;
    top: -100%;
    // background: rgba();
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 46px;
      color: #0556b3;
    }
  }
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .chartsdom{
    width: 100%;
    height: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/EXCharts/index.vue